
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "picture.icon",
  "use": "picture.icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"picture.icon\"><path d=\"M959.884 128c.04.034.082.076.116.116v767.77c-.034.04-.076.082-.116.116H64.114a.891.891 0 01-.114-.116V128.114c.034-.04.076-.082.114-.114h895.77zM960 64H64C28.8 64 0 92.8 0 128v768c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z\" /><path d=\"M832 288c0 53.02-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96zM896 832H128V704l224-384 256 320h64l224-192z\" /></symbol>"
});
    sprite.add(symbol);
    export default class PictureIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="picture.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/picture.icon.svg